import {Injectable} from '@angular/core';
import {AuthSessionApiService} from '@npck/auth-frontend-api';
import {RouterService} from '@npck/libs/commons';
import {Path} from '../path';
import {AuthHolderService} from './auth-holder.service';

@Injectable({
    providedIn: 'root',
})
export class AuthHolderTokenService {

    constructor(
        private routerService: RouterService,
        private authHolderService: AuthHolderService,
        private authSessionApiService: AuthSessionApiService,
    ) {
    }

    handleNextFactor(): void {
        this.authSessionApiService.getNextStepToken().subscribe(tokenResponse => {
            if (this.authHolderService.authSessionData?.skipSms) {
                if (this.authHolderService.authSessionData.hasOrganizationAuth) {
                    this.authHolderService.storeOrganizationToken(tokenResponse.authSessionToken);
                    this.routerService.navigate(Path.BIN);
                } else {
                    this.authHolderService.storeAuthSessionToken(tokenResponse.authSessionToken);
                    this.routerService.navigate(Path.OAUTH_AUTHORIZE);
                }
            } else {
                this.authHolderService.storeSecondFactorToken(tokenResponse.secondFactorToken);
                this.routerService.navigate(Path.CODE);
            }
        });
    }
}
